export const createWebSocketConnection = ({
  websocketUrl,
  onOpen,
  onMessage,
  onError,
  onClose,
}: {
  websocketUrl: string;
  onOpen: (socket: WebSocket) => void;
  onMessage: (socket: WebSocket, event: MessageEvent) => void;
  onError: (error: Error) => void;
  onClose: () => void;
}): WebSocket => {
  const socket = new WebSocket(websocketUrl);

  socket.onopen = () => {
    console.log("WebSocket connection established.");
    onOpen(socket);
  };

  socket.onmessage = (event) => {
    onMessage(socket, event);
  };

  socket.onerror = (error) => {
    console.error("WebSocket error:", error);
    onError(new Error("WebSocket connection error."));
  };

  socket.onclose = () => {
    console.log("WebSocket connection closed.");
    onClose();
  };

  return socket;
};

export const sendMessage = (socket: WebSocket, message: object): void => {
  if (socket.readyState === WebSocket.OPEN) {
    socket.send(JSON.stringify(message));
  } else {
    console.error("WebSocket is not open. Cannot send message.");
  }
};

export const closeWebSocketConnection = (socket: WebSocket): void => {
  if (socket.readyState === WebSocket.OPEN) {
    socket.close();
  }
};
